/*eslint-disable*/
import React, {useState, useEffect} from "react";
import { useSelector } from "react-redux";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TrioBanner from "../../assets/img/triobanner.png";
// core components
import styles from "assets/jss/material-kit-react/views/componentsSections/downloadStyle.js";

const useStyles = makeStyles(styles);

export default function SectionDownload() {
  const classes = useStyles();
  const socialinfos = useSelector(state => state.socialinfos);
  const [dataInfos, setInfos] = useState({});

  useEffect(()=>{
    if(socialinfos.infos){
      setInfos(socialinfos.infos);
    }
  },[socialinfos.infos]);

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer className={classes.textCenter} justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>Baixe o aplicativo na Google ou Apple Store.</h2>
            <h3 className={classes.title}>Aproveite agora mesmo nossas vantagens.</h3>
            <img className={classes.triobanner} src={TrioBanner} alt="Ambulancia App Banner" />
            <h4 className={classes.description}>São 30 dias gratuitos para o motorista conhecer nosso sistema.</h4>
            <h3 className={classes.title}>Aplicativo do Passageiro</h3>
          </GridItem>
          <GridItem xs={12} sm={8} md={6}>
            <a href={dataInfos.rider_appleLink}><img src="https://dev.exicube.com/images/appstore.png" alt="Ambulancia Apple Store Link"/></a>
            <span style={{marginRight: '5px'}}></span>
            <a href={dataInfos.rider_playLink}><img src="https://dev.exicube.com/images/playstore.png" alt="Ambulancia Playstore Link"/></a>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
           <br />
           <br />
           <h3 className={classes.title}>Aplicativo do Motorista</h3>
          </GridItem>
          <GridItem xs={12} sm={8} md={6}>
            <a href={dataInfos.driver_appleLink}><img src="https://dev.exicube.com/images/appstore.png" alt="Ambulancia Apple Store Link"/></a>
            <span style={{marginRight: '5px'}}></span>
            <a href={dataInfos.driver_playLink}><img src="https://dev.exicube.com/images/playstore.png" alt="Ambulancia Playstore Link"/></a>
          </GridItem>
        </GridContainer>

      </div>
    </div>
  );
}
